import { render, staticRenderFns } from "./ViewJob.vue?vue&type=template&id=2a1a8a72&scoped=true&"
import script from "./ViewJob.vue?vue&type=script&lang=js&"
export * from "./ViewJob.vue?vue&type=script&lang=js&"
import style0 from "./ViewJob.vue?vue&type=style&index=0&id=2a1a8a72&prod&lang=css&scoped=true&"
import style1 from "./ViewJob.vue?vue&type=style&index=1&id=2a1a8a72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a8a72",
  null
  
)

export default component.exports